import { render, staticRenderFns } from "./TotalPriceSummary.vue?vue&type=template&id=10042526&scoped=true&"
import script from "./TotalPriceSummary.vue?vue&type=script&lang=js&"
export * from "./TotalPriceSummary.vue?vue&type=script&lang=js&"
import style0 from "./TotalPriceSummary.vue?vue&type=style&index=0&id=10042526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10042526",
  null
  
)

export default component.exports